import React, { useContext } from 'react';
import Header from 'components/CardShell/Header';
import styles from './styles.scss';
import ShipmentFilterContext from './ShipmentFiltersContext';

const ShipmentFilterPageSummary = (props) => {
  const {
    carrierIntegrations, customEventTypes, availableCalculatedEvents, availableShipmentStates,
  } = useContext(ShipmentFilterContext);

  const getSummaryList = (names) => (
    <ul className={styles.summaryList}>
      {names.map(name => (
        <li key={name}>{name}</li>
      ))}
    </ul>
  );

  return (
    <div className={styles.cardsection}>
      <div className={styles.cardSectionInner}>
        <Header>Summary</Header>
        {props.summaryData && (
        <div className={styles.summaryContainer}>
          {props.summaryData.name && <h5 className={styles.summarySubHeader}>Name: {props.summaryData.name}</h5>}

          {props.summaryData.carrier_integrations && props.summaryData.carrier_integrations.length > 0 && (
            <>
              <h5 className={styles.summarySubHeader}>Carriers:</h5>
              {getSummaryList(
                props.summaryData.carrier_integrations.map(pci => {
                  const carrier = carrierIntegrations.find(ci => ci.id === pci.id);
                  return carrier ? carrier.name : '';
                }),
              )}
            </>
          )}

          {props.summaryData.states && props.summaryData.states.length > 0 && (
          <>
            <h5 className={styles.summarySubHeader}>Shipment States:</h5>
            {getSummaryList(
              props.summaryData.states.map(pstate => {
                const availableState = availableShipmentStates.find(astate => astate.state_key === pstate.state);
                return availableState ? availableState.state_name : '';
              }),
            )}
          </>
          )}

          {props.summaryData.calculated_events && props.summaryData.calculated_events.length > 0 && (
          <>
            <h5 className={styles.summarySubHeader}>Calculated Events:</h5>
            {getSummaryList(
              props.summaryData.calculated_events.map(pce => {
                const calcEvent = availableCalculatedEvents.find(ce => ce.id === pce);
                return calcEvent ? calcEvent.name : '';
              }),
            )}
          </>
          )}

          {props.summaryData.custom_event_types && props.summaryData.custom_event_types.length > 0 && (
          <>
            <h5 className={styles.summarySubHeader}>Custom Event Types:</h5>
            {getSummaryList(
              props.summaryData.custom_event_types.map(pcet => {
                const custEventType = customEventTypes.find(cet => cet.id === pcet);
                return custEventType ? custEventType.name : '';
              }),
            )}
          </>
          )}

          {props.summaryData.shipment_types && props.summaryData.shipment_types.length > 0 && (
            <>
              <h5 className={styles.summarySubHeader}>Shipment Types:</h5>
              {getSummaryList(props.summaryData.shipment_types)}
            </>
          )}

          {props.summaryData.tags && props.summaryData.tags.length > 0 && (
          <>
            <h5 className={styles.summarySubHeader}>Shipment Tags:</h5>
            {getSummaryList(props.summaryData.tags)}
          </>
          )}

          {props.summaryData.shipmentFilterExpiryMinutes && <h5 className={styles.summarySubHeader}>Expiry: {props.summaryData.shipmentFilterExpiryMinutes} minutes</h5>}

          {(props.summaryData.single_trigger_grouping_metakey || props.summaryData.single_trigger_timespan_in_minutes > 0) && (
            <>
              <h5 className={styles.summarySubHeader}>Restrict trigger:</h5>
              {getSummaryList([
                props.summaryData.single_trigger_grouping_metakey && `Grouping metakey: ${props.summaryData.single_trigger_grouping_metakey}`,
                props.summaryData.single_trigger_timespan_in_minutes > 0 && `Trigger reset in minutes: ${props.summaryData.single_trigger_timespan_in_minutes}`,
              ].filter(Boolean))}
            </>
          )}

          {(props.summaryData.smartFilterWaitType
            || props.summaryData.smartFilterWaitTimeMinutes
            || props.summaryData.smartFilterPriority
            || props.summaryData.smartFilterTimeWindowEarlyHour
            || props.summaryData.smartFilterTimeWindowLateHour
          ) && (
            <>
              <h5 className={styles.summarySubHeader}>Smart Filter Settings:</h5>
              {getSummaryList([
                props.summaryData.smartFilterWaitType && `Wait type: ${props.summaryData.smartFilterWaitType}`,
                props.summaryData.smartFilterWaitTimeMinutes && `Wait time: ${props.summaryData.smartFilterWaitTimeMinutes}`,
                props.summaryData.smartFilterPriority && `Priority: ${props.summaryData.smartFilterPriority}`,
                props.summaryData.smartFilterTimeWindowEarlyHour && `Earliest hour (Europe/London): ${props.summaryData.smartFilterTimeWindowEarlyHour}`,
                props.summaryData.smartFilterTimeWindowLateHour && `Latest hour (Europe/London): ${props.summaryData.smartFilterTimeWindowLateHour}`,
              ].filter(Boolean))}
            </>
          )}
        </div>
        )}
      </div>
    </div>
  );
};

export default ShipmentFilterPageSummary;
